import { createColumn, defaultColumns, inputTextField } from '../_defaults/columns'

export const columns = [
  createColumn({
    label: 'Name',
    field: 'name',
    type: 'text',
    component: inputTextField({ req: false, type: 'text' })
  }),
  createColumn({
    label: 'Normalized Name',
    field: 'normalizedName',
    type: 'text',
    component: inputTextField({ req: false, type: 'text' })
  }),
  createColumn({
    label: 'Description',
    field: 'description',
    type: 'textarea',
    component: inputTextField({ req: false, type: 'textarea' })
  }),
  createColumn({
    label: 'Created Date',
    field: 'createdDate',
    type: 'date',
    component: {
      is: 'q-datetime',
      props: {
        type: 'datetime',
        format24h: false,
        format: 'MMM DD YYYY h:mm a'
      },
      validation: {
        required: false
      }
    }
  }),
  createColumn({
    label: 'Concurrency Stamp',
    field: 'concurrencyStamp',
    type: 'textarea',
    component: inputTextField({ req: false, type: 'textarea' })
  }),
  createColumn({
    label: 'IP Address',
    field: 'ipaddress',
    type: 'textarea',
    component: inputTextField({ req: false, type: 'textarea' })
  })
].concat(defaultColumns)
